export type TrackingProvider =
  | "amplitude"
  | "meta"
  | "appsflyer"
  | "tiktok"
  | "snapchat"
  | "ga4"
  | "openai";

// No-op in production. Buffers every analytics payload into
// `window.__trackedEvents` when `enableTrackingCapture` armed the page.
// Lets e2e specs assert payload contracts without relying on real SDKs.
export const captureForTest = (
  provider: TrackingProvider,
  event: string,
  properties: Record<string, unknown> = {},
) => {
  if (typeof window === "undefined" || !window.__trackingTestMode) return;
  window.__trackedEvents = window.__trackedEvents ?? [];
  window.__trackedEvents.push({ provider, event, properties });
};
